<template>
  <div id="main" class="home">
    <img alt="Vue logo" src="../assets/postexpress-logo.png">
    <HelloWorld />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'Home',
  components: {
    HelloWorld,
  },
});
</script>

<style scoped>
#main img {
  margin-top: 15px;
  width: 125px;
  height: auto;
}
</style>